import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHd"><Path d="M15.3984 13.8545H14.749V10.0996H15.3984C16.3848 10.0996 16.9756 10.7344 16.9756 11.916V11.9258C16.9756 13.2246 16.4336 13.8545 15.3984 13.8545Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M2 20V4H22V20H2ZM5.08105 8.4541V15.5H7.15137V12.7754H9.63184V15.5H11.7021V8.4541H9.63184V11.1348H7.15137V8.4541H5.08105ZM12.6787 8.4541V15.5H15.6914C17.8252 15.5 19.085 14.1816 19.085 11.9258V11.916C19.085 9.66504 17.8252 8.4541 15.6914 8.4541H12.6787Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHd;
